import './css/dashboardtable.css';
import React, { useState,useEffect} from "react";
import axios from '../../config/index';
import { Link, useNavigate } from 'react-router-dom';




function AllGalleryPage(){


        
    useEffect(() => {
        axios
    .get('session-admin')
    .then((res) => {
        if (res.data.valid) {

            if(res.data.type == "admin"){

            }else{
                navigate('/admin-login');
            }

        } else {

        }
    })
    .catch((err) => console.log(err));
    },[]);



    
    const navigate = useNavigate();
    const [AllGallery, setAllGallery] = useState([]);

    axios.defaults.withCredentials = true;





    const getAllGallery = ()=>{
        axios.post('AllItems', {
            table: 'gallery',
        })
        .then((res) => {
            if (res.data) {
                console.log(res.data)
                setAllGallery(res.data);
            } else {
                console.log("Error happened");
            }
        })
        .catch((err) => console.log(err));
    };
    




    const getIfLogin= ()=>{
        
    axios
    .get('session')
    .then((res) => {
        if (!res.data.valid) {
            console.log(res.data.valid);
            navigate('/admin-login');

        }else{
            console.log(res.data.valid);

        }
    })
    .catch((err) => console.log(err));

    }





    const deleteItem = (id) => {
        axios
        .delete(`delete-item/${id}`, {
            data: {
            table: 'gallery',
            },
        })
        .then((response) => {
            if (response.data.message === 'Item deleted successfully') {
                getAllGallery();
            } else {
            console.error('Failed to delete result:', response.data.message);
            }
        })
        .catch((error) => {
            console.error('Error deleting result:', error);
        });
    };




useEffect(() => {

    getAllGallery();
    getIfLogin();

}, []);




    

    return(
        <>
            <section className='dashboard'>



                <div className='results-table'>
                <Link className='new-item' to='/add-gallery'> +  صورة جديدة</Link>

                <table>

                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>الصورة</th>

                            <th>الخيارات</th>

                        </tr>
                    </thead>
                    <tbody>
                    {AllGallery.length ? (

                        AllGallery.map(gallery => {

                        return (
                            <tr key={gallery.id}>
                            <td><h6>{gallery.id}</h6></td>

                            <td><img src={`uploads/${gallery.img}`} alt="User avatar"/></td>







                            <td>
                                <Link className='edit' to={`/edit-gallery?id=${gallery.id}`}> <i class="las la-edit"></i> </Link>
                            </td>

                            
                            <td>
                                <button className='delete' onClick={() => deleteItem(gallery.id)}> <i class="las la-trash-alt"></i> </button>
                            </td>


                            </tr>
                        );
                        })): 
                        
                        
                        
                        (
                            <tr>
                                <td colSpan={5}>تحميل...</td>
                            </tr>
                            )}
                    </tbody>
                </table>

                </div>
            </section>
        
        </>
    )
}

export default AllGalleryPage;